<template>
  <form @submit.prevent>
    <div class="row">
      <div class="col-12">
        <fg-input type="text"
          placeholder="Full Name"
          :class="{ 'form-group--error': $v.name.$error }"
          v-model="$v.name.$model">
        </fg-input>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="form-group">
        <textarea placeholder="Description"
          class="form-control"
          v-model="description" />
        </div>
      </div>
    </div>
    <div class="text-left">
      <p-button type="info"
        :loading="isEditingGroup"
        @click.native.prevent="editGroup">
        Save
      </p-button>
    </div>
    <div class="clearfix"></div>
  </form>
</template>

<script>
import { notify } from '../../services/notify';
import { required } from 'vuelidate/lib/validators';

export default {
  name: 'EditGroupForm',
  props: {
    group: Object
  },
  data() {
    return {
      name: "",
      description: "",
      isEditingGroup: false
    }
  },
  validations: {
    name: { required }
  },
  created() {
    this.name = this.group.name;
    this.description = this.group.description;
  },
  methods: {
    async editGroup() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        notify().error('Please provide a name and description for the group.')
        return;
      }

      this.isEditingGroup = true;
      const success = await this.$store.dispatch('group/updateGroup', {
        id: this.group.id,
        name: this.name,
        description: this.description,
        organization_id: this.group.organization_id,
        is_active: this.group.is_active
      });

      if (success) {
        this.$emit('hasUpdate');
      }
      this.isEditingGroup = false;
    }
  }
};
</script>
